import React from 'react';

/**
 * Shown while lazy route chunks load — matches site chrome, avoids blank flash.
 */
const PageLoadingFallback: React.FC = () => (
  <div
    className="min-h-[50vh] flex flex-col items-center justify-center px-4 py-24"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div
      className="h-10 w-10 rounded-full border-2 border-white/10 border-t-neon-blue animate-spin motion-reduce:animate-none mb-4"
      aria-hidden
    />
    <p className="text-sm text-gray-500 tracking-wide">Loading page…</p>
    <span className="sr-only">Loading page, please wait.</span>
  </div>
);

export default PageLoadingFallback;
